import React from 'react';
import PropTypes from 'prop-types';
import Config from '@/config';

const EmbedCode = ({ universal_quoter }) => {
  return (
    <div>
      <p style={{ fontFamily: 'monospace', lineHeight: '1.8em', fontSize: '12px' }}>
        {`<link href='${Config.UQ_URL}@css/reset.css' rel='stylesheet' type='text/css'>`}
        <br />
        {"<script type='text/javascript'>"}
        <br />
        <span
          style={{ marginLeft: '20px' }}
        >{`window.HEXURE_UQ_CONFIG = { id: '${universal_quoter.token}' };`}</span>
        <br />
        {'</script>'}
        <br />
        {"<div id='universal-quoter-component'></div>"}
        <br />
        {`<script type='text/javascript' src='${Config.UQ_URL}js/universal_quoter.widget.js'></script>`}
      </p>
    </div>
  );
};

EmbedCode.propTypes = {
  universal_quoter: PropTypes.object
};

export default EmbedCode;
